import { use, useEffect, useState } from "react";
import GroupDropdown from "../GroupDropdown/GroupDropdown";
import { BiPlus } from "react-icons/bi";
import "../Nav/Nav.css";
import AddEditGroupModal from "../AddEditGroupModal/AddEditGroupModal";
import { MdMenu } from "react-icons/md";
import { GetCurrentUser } from "../../../../Services/Authorization/AuthorizationManager";
import { CheckPanelPermissions } from "../../../../Services/Permissions/PermissionManager";
import { Permissions } from "../../../../Services/Permissions/Data/Permissions";

const Nav = ({serverData}) => {
    const [showGroupAdd, setShowGroupAdd] = useState(false);

    const [width, setWidth] = useState(window.innerWidth);
    const [showMobileNav, setShowMobileNav] = useState(false);

    useEffect(() => {
        window.addEventListener('resize', () => {setWidth(window.innerWidth)});
        return () => {
            window.removeEventListener('resize', () => {setWidth(window.innerWidth)});
        }
    }, [])

    const user = GetCurrentUser();

    return (
        <>
            { width <= 1000 &&
                <>
                    { showMobileNav &&
                        <div className="nav-mobile">
                            <nav>
                                <div onClick={() => setShowMobileNav(false)} className="logotype-y center-content">
                                    <img src="../images/svg/netraLogo.svg" className="size-10 border border-glgray-700 rounded-md"/>
                                </div>
                                <div className="serverList">
                                    { serverData.length > 0 &&
                                        serverData.map(data => {
                                            return (<GroupDropdown key={`group_${data.group.id}`} group={data.group} servers={data.servers}/>);
                                        })
                                    }
                                    { CheckPanelPermissions(Permissions[1], user.Permissions, true) &&
                                        <div className="mt-4 center-y">
                                            <button onClick={() => setShowGroupAdd(true)}><BiPlus className="btnIcon"/>Dodaj nową grupę</button>
                                        </div>
                                    }
                                    { showGroupAdd &&
                                        <AddEditGroupModal hide={() => setShowGroupAdd(false)}/>
                                    }
                                    
                                </div>
                            </nav>
                        </div>  
                    }  
                    { !showMobileNav &&
                        <div onClick={() => setShowMobileNav(true)} className="mobile-nav-button center-content">
                            <MdMenu className="w-10 h-10"/>
                        </div> 
                    }                
                </>         
            }
            { width > 1000 &&
                <nav>
                    <div className="logotype-y center-content">
                        <img src="../images/svg/netraLogo.svg" className="size-10 border border-glgray-700 rounded-md"/>
                        <span>Netra Panel</span>
                    </div>
                    <div className="serverList">
                        { serverData.length > 0 &&
                            serverData.map(data => {
                                return (<GroupDropdown key={`group_${data.group.id}`} group={data.group} servers={data.servers}/>);
                            })
                        }
                        { serverData.length == 0 &&
                            <p className="text-center">Brak danych...</p>
                        }

                        { CheckPanelPermissions(Permissions[1], user.Permissions, true) && 
                            <div className="mt-4 center-y">
                                <button onClick={() => setShowGroupAdd(true)}><BiPlus className="btnIcon"/>Dodaj nową grupę</button>
                            </div>
                        }

                        { showGroupAdd &&
                            <AddEditGroupModal hide={() => setShowGroupAdd(false)}/>
                        }
                        
                    </div>
                </nav>       
            }            
        </>
    )
}

export default Nav;